import {
  getAuthToken,
  getMe,
  postLogin,
  setAuthToken,
  type User,
} from "@/lib/api";

const USER_STORAGE_KEY = "url_sensor.user";

export async function login(email: string, password: string): Promise<User> {
  const token = await postLogin(email, password);
  setAuthToken(token.access_token);
  const user = await getMe();
  cachedUser = user;
  if (typeof window !== "undefined") {
    window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  }
  return user;
}

export function logout(): void {
  setAuthToken(null);
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(USER_STORAGE_KEY);
  }
}

export function getToken(): string | null {
  return getAuthToken();
}

export function isAuthenticated(): boolean {
  return getAuthToken() !== null;
}

let cachedUser: User | null | undefined = undefined;

export function getCachedUser(): User | null {
  if (cachedUser !== undefined) return cachedUser;
  if (typeof window === "undefined") {
    cachedUser = null;
    return null;
  }
  const raw = window.localStorage.getItem(USER_STORAGE_KEY);
  if (!raw) {
    cachedUser = null;
    return null;
  }
  try {
    cachedUser = JSON.parse(raw) as User;
  } catch {
    cachedUser = null;
  }
  return cachedUser;
}

export async function getCurrentUser(force = false): Promise<User | null> {
  if (!isAuthenticated()) return null;
  if (!force) {
    const cached = getCachedUser();
    if (cached) return cached;
  }
  try {
    const u = await getMe();
    cachedUser = u;
    if (typeof window !== "undefined") {
      window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(u));
    }
    return u;
  } catch {
    return null;
  }
}

export function clearUserCache(): void {
  cachedUser = undefined;
}
